document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.product-carousel-3d');
  
  sections.forEach(function(section) {
    const track = section.querySelector('[data-carousel-track]');
    const items = Array.from(section.querySelectorAll('.carousel-item'));
    const dots = Array.from(section.querySelectorAll('.dot'));
    const buttons = section.querySelectorAll('.subscribe-button');
    
    // Apply button colors
    buttons.forEach(function(button) {
      const color = button.getAttribute('data-button-color');
      if (color) {
        button.style.backgroundColor = color;
      }
    });
    
    let currentIndex = 0;
    let isDragging = false;
    let startX = 0;
    let currentX = 0;
    const dragThreshold = 50;
    
    const totalItems = items.length;
    const angleStep = 360 / totalItems;
    
    function updateCarousel(animate) {
      if (animate === false) {
        track.style.transition = 'none';
      }
      
      items.forEach(function(item, i) {
        const offset = i - currentIndex;
        const angle = offset * angleStep;
        const absOffset = Math.abs(offset);
        
        const radius = 400;
        const x = Math.sin(angle * Math.PI / 180) * radius;
        const z = Math.cos(angle * Math.PI / 180) * radius - radius;
        
        const scale = 1 - (Math.abs(z) / radius) * 0.5;
        const opacity = scale;
        
        const zIndex = absOffset === 0 ? 100 : 50 - absOffset;
        
        item.style.transform = 'translate(-50%, -50%) translate3d(' + x + 'px, 0, ' + z + 'px) scale(' + scale + ')';
        item.style.opacity = opacity;
        item.style.zIndex = zIndex;
        item.style.pointerEvents = absOffset === 0 ? 'auto' : 'none';
      });
      
      dots.forEach(function(dot, i) {
        if (i === currentIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
      
      if (animate === false) {
        setTimeout(function() {
          track.style.transition = '';
        }, 10);
      }
    }
    
    function goToIndex(index) {
      currentIndex = ((index % totalItems) + totalItems) % totalItems;
      updateCarousel();
    }
    
    function next() {
      goToIndex(currentIndex + 1);
    }
    
    function prev() {
      goToIndex(currentIndex - 1);
    }
    
    function startDrag(e) {
      isDragging = true;
      startX = e.type.indexOf('mouse') !== -1 ? e.clientX : e.touches[0].clientX;
      currentX = startX;
      track.style.cursor = 'grabbing';
    }
    
    function drag(e) {
      if (!isDragging) return;
      e.preventDefault();
      currentX = e.type.indexOf('mouse') !== -1 ? e.clientX : e.touches[0].clientX;
    }
    
    function endDrag() {
      if (!isDragging) return;
      
      isDragging = false;
      track.style.cursor = 'grab';
      
      const diff = currentX - startX;
      
      if (Math.abs(diff) > dragThreshold) {
        if (diff > 0) {
          prev();
        } else {
          next();
        }
      }
    }
    
    track.addEventListener('mousedown', startDrag);
    track.addEventListener('touchstart', startDrag);
    
    document.addEventListener('mousemove', drag);
    document.addEventListener('touchmove', drag);
    
    document.addEventListener('mouseup', endDrag);
    document.addEventListener('touchend', endDrag);
    
    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() {
        goToIndex(i);
      });
    });
    
    section.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft') prev();
      if (e.key === 'ArrowRight') next();
    });
    
    updateCarousel(false);
  });
});